export default __webpack_public_path__ + "static/media/image_icon.a90a8bb3.svg";